import React from 'react';
import { actorInfo } from '../mock/komalData';
import { Play, ExternalLink } from 'lucide-react';

const ShowreelSection = () => {
  const getYouTubeEmbedUrl = (url) => {
    const videoId = url.split('youtu.be/')[1]?.split('?')[0] || url.split('v=')[1]?.split('&')[0];
    return `https://www.youtube.com/embed/${videoId}?autoplay=0&rel=0`;
  };

  return (
    <section id="showreel" className="min-h-0 lg:min-h-screen bg-[#0a0a0a] py-12 lg:py-20 px-4 sm:px-8 lg:px-12 lg:flex lg:items-center">
      <div className="max-w-7xl mx-auto w-full">
        {/* Section Header - Match other sections */}
        <div className="text-center mb-8 lg:mb-16">
          <h2 className="font-display text-5xl sm:text-6xl md:text-7xl font-black text-white mb-3 lg:mb-4">
            THE <span className="text-[#FF6B6B]">SHOWREEL</span>
          </h2>
          <div className="w-20 lg:w-24 h-1 bg-[#FF6B6B] mx-auto mb-4 lg:mb-6"></div>
          <p className="text-gray-400 text-sm lg:text-lg max-w-2xl mx-auto px-2 leading-relaxed">
            Watch my journey as a performer, capturing moments of truth, intensity, and authenticity on screen.
          </p>
        </div>

        {/* Video Container */}
        <div className="max-w-5xl mx-auto">
          <div className="relative group">
            {/* Glow Effect */}
            <div className="absolute -inset-1 bg-gradient-to-r from-[#FF6B6B] via-[#FF8E53] to-[#4ECDC4] rounded-lg blur-xl opacity-30 group-hover:opacity-50 transition-opacity duration-500"></div>
            
            {/* Video Frame */}
            <div className="relative bg-black rounded-lg overflow-hidden shadow-2xl aspect-video">
              <iframe
                src={getYouTubeEmbedUrl(actorInfo.showreelUrl)}
                title="Komal Verma Showreel"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>
          </div>

          {/* CTA Below Video */}
          <div className="mt-5 lg:mt-12 text-center">
            <a
              href={actorInfo.showreelUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[#FF6B6B] hover:text-[#FF8E53] transition-colors group"
            >
              <span className="text-sm lg:text-lg font-medium">Watch on YouTube</span>
              <ExternalLink size={16} className="lg:w-5 lg:h-5 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        </div>

        {/* Quick Stats */}
        <div className="mt-8 lg:mt-20 grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-8 max-w-4xl mx-auto">
          <div className="text-center bg-[#1a1a1a]/30 lg:bg-transparent p-4 lg:p-0 rounded-lg">
            <div className="text-3xl lg:text-4xl font-black text-[#FF6B6B] mb-1 lg:mb-2">4+</div>
            <div className="text-gray-400 text-xs lg:text-sm uppercase tracking-wider leading-tight">Years Experience</div>
          </div>
          <div className="text-center bg-[#1a1a1a]/30 lg:bg-transparent p-4 lg:p-0 rounded-lg">
            <div className="text-3xl lg:text-4xl font-black text-[#4ECDC4] mb-1 lg:mb-2">7+</div>
            <div className="text-gray-400 text-xs lg:text-sm uppercase tracking-wider leading-tight">Projects</div>
          </div>
          <div className="text-center bg-[#1a1a1a]/30 lg:bg-transparent p-4 lg:p-0 rounded-lg">
            <div className="text-3xl lg:text-4xl font-black text-[#FFD700] mb-1 lg:mb-2">3</div>
            <div className="text-gray-400 text-xs lg:text-sm uppercase tracking-wider leading-tight">Languages</div>
          </div>
          <div className="text-center bg-[#1a1a1a]/30 lg:bg-transparent p-4 lg:p-0 rounded-lg">
            <div className="text-3xl lg:text-4xl font-black text-[#FF6B6B] mb-1 lg:mb-2">2</div>
            <div className="text-gray-400 text-xs lg:text-sm uppercase tracking-wider leading-tight">Elite Training</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShowreelSection;
